import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useState } from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { BSSConfirmDialog} from "../../../form/BSSDialog";
const {logger} = useBSSLogger();


const DialogFiltroFatturati = ({filtri, setFiltri, dialogFiltroFatturati, setDialogFiltroFatturati}) => {

    const [filtroFatturati, setFiltroFatturati] = useState(null);

    const filtraFatturati = (filtroFatturati) => {
        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                fatturato: filtroFatturati
            }, 
            skip: 0
        });
        setFiltroFatturati(null)
        setDialogFiltroFatturati({mostra: false})
    }

    return (
        <BSSConfirmDialog
            title={__t("mostrainbaseafattura")}                                                        
            open={dialogFiltroFatturati.mostra} 
            undoAction={e => setDialogFiltroFatturati({mostra: false})} 
            confirmAction={e => {
                filtraFatturati(filtroFatturati)
            }}
            sx={{"& .MuiDialogContent-root": {p: 0}}}
        >
            <Box p={2}>
                <RadioGroup
                    defaultValue={null}
                    name="radio-buttons-group-fatturato"
                    onChange={e => {
                        filtraFatturati(e.target.value)
                        setDialogFiltroFatturati({mostra: false})
                    }}
                >
                    <FormControlLabel value={true} control={<Radio />} label={__t("fatturato")} />
                    <FormControlLabel value={false} control={<Radio />} label={__t("nonfatturato")} />
                    <FormControlLabel value={null} control={<Radio />} label={__t("indifferente")} />
                </RadioGroup>
                
            </Box>

        </BSSConfirmDialog>
    )
}

export default DialogFiltroFatturati;